<template>
  <chart-container :title="title" :containerClasses="{ 'pa-0': true }">
    <GmapMap
      ref="mapRef"
      :center="center"
      :options="gmapsOptions"
      map-type-id="satellite"
      v-bind:style="{
        height: computedOptions.height,
        border: '1px solid #999',
      }"
    ></GmapMap>
  </chart-container>
</template>


<script>
/* 
  global google
*/
import _merge from "lodash.merge";

import ChartContainer from "@/components/dashboard/ChartContainer.vue";
import { GmapsOptions } from "@/commons/chart-commons.js";

export default {
  data() {
    return {
      mapRef: undefined,
      center: GmapsOptions.defaultLocation,
      gmapsOptions: GmapsOptions.mapOptions,
    };
  },
  components: {
    ChartContainer,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    height: {
      type: Number,
      required: false,
    },
  },
  mounted() {
    this.$refs.mapRef.$mapPromise.then((mapRef) => {
      console.log("mapInit", mapRef);
      this.mapRef = mapRef;
      this.adjustMap();
    });
  },
  methods: {
    adjustMap() {
      const googlePoints = this.computedPoints.map(
        (point) => new google.maps.LatLng(point.lat, point.lng)
      );
      const bounds = new google.maps.LatLngBounds();
      googlePoints.forEach((gp) => {
        bounds.extend(gp);
      });
      this.mapRef.fitBounds(bounds);
      this.mapRef.panToBounds(bounds);
      if (this.$heatmap) {
        this.$heatmap.setMap(null);
      }
      this.$heatmap = new google.maps.visualization.HeatmapLayer({
        data: new google.maps.MVCArray(googlePoints),
        map: this.mapRef,
      });
    },
  },
  computed: {
    computedOptions() {
      const localOptions = {
        height: this.computedHeigth + "px",
      };
      return _merge({}, localOptions);
    },
    computedPoints() {
      return this.options.points.map((point) => {
        return point.position;
      });
    },
    computedHeigth() {
      switch (this.height) {
        case 185:
          return 217;
        case 200:
          return 232;
        case 300:
          return 315.5;
        case 340:
          return 372;
        default:
          return (this.height + 6 || GmapsOptions.height) * 1.03;
      }
    },
  },
  watch: {
    computedPoints() {
      this.adjustMap();
    },
  },
};
</script>
